import { useQuery } from '@tanstack/vue-query'
import type { MaybeRefOrGetter } from 'vue'
import { fetchOAuthConfig } from '~/api/login'

/**
 * 第三方登录公开配置（GET /account/oauth/config）。
 *
 * - 渠道是否展示、Google client_id、Telegram bot_id 均以接口为准，前端不再写死；
 * - 取不到（请求失败 / 未返回）时按「未启用」处理，对应入口不展示；
 * - `enabled` 为外部开关（如登录抽屉是否打开），避免未登录页面一进来就请求。
 */
export function useOAuthConfig(enabled: MaybeRefOrGetter<boolean> = true) {
  const { data } = useQuery({
    queryKey: ['auth', 'oauth-config'],
    queryFn: fetchOAuthConfig,
    enabled: () => toValue(enabled),
    staleTime: 300_000,
    refetchOnWindowFocus: false,
    retry: 1,
  })

  const googleClientId = computed(() =>
    data.value?.google?.enabled ? (data.value.google.client_id ?? '') : '',
  )
  const telegramBotId = computed(() =>
    data.value?.telegram?.enabled ? (data.value.telegram.bot_id ?? '') : '',
  )

  /** 启用且标识非空才展示入口 */
  const googleEnabled = computed(() => googleClientId.value !== '')
  const telegramEnabled = computed(() => telegramBotId.value !== '')

  return { googleClientId, googleEnabled, telegramBotId, telegramEnabled }
}
